/* eslint-disable max-lines */
import { defaultState } from '../../reducers/pagesMeta';
import { TPagesMetaState } from '../../types/pagesMeta';
import { PageMetaDefault } from '../../constants';
import {
  EAudienceAccessType,
  ECategory,
  EType,
  EUserAccessType,
  IPageInfoSchema,
} from '../../repositories/journal/entities/page_info/PageInfoSchema';

export const mkPagesMeta = (data?: IPageInfoSchema[]): IPageInfoSchema[] => {
  return [
    PageMetaDefault,
    {
      rubricId: 0,
      category: null,
      metaTitle: 'ЦИАН - новости рынка недвижимости Москвы и России',
      metaDescription:
        'ЦИАН - новости рынка недвижимости в России. Новости об аренде и продаже квартир, офисов, домов и другой недвижимости. Новости о новостройках в вашем регионе',
      metaKeywords: 'новости, недвижимость, информация, москва, россия, квартиры, офисы, помещения, дома',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/novosti/',
      noIndex: false,
      type: EType.News,
      title: 'Новости о недвижимости',
      breadCrumbName: 'Новости',
      breadCrumbParents: ['/magazine/'],
      pathname: '/novosti/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Company,
      metaTitle: 'Новости от застройщиков, агентств недвижимости и других компаний - ЦИАН',
      metaDescription:
        'ЦИАН - самые свежие и актуальные новости от застройщиков, агентств недвижимости и других компаний. Информационные и аналитические статьи, обзоры, комментарии специалистов',
      metaKeywords: 'новости, рынок недвижимости, циан, агентства недвижимости, застройщики',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/novosti/company/',
      noIndex: false,
      type: EType.News,
      title: 'Новости компании',
      breadCrumbName: 'Новости компании',
      breadCrumbParents: ['/magazine/', '/novosti/'],
      pathname: '/novosti/company/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Market,
      metaTitle: 'Новости рынка недвижимости - ЦИАН',
      metaDescription:
        'ЦИАН - самые свежие и актуальные новости рынка недвижимости. Информационные и аналитические статьи, обзоры, комментарии специалистов',
      metaKeywords: 'новости, рынок недвижимости, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/novosti/market/',
      noIndex: false,
      type: EType.News,
      title: 'Новости рынка недвижимости',
      breadCrumbName: 'Новости рынка',
      breadCrumbParents: ['/magazine/', '/novosti/'],
      pathname: '/novosti/market/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: null,
      metaTitle: 'Блоги риэлторов и других специалистов рынка недвижимости России - ЦИАН',
      metaDescription:
        'ЦИАН - авторские колонки, блоги специалистов рынка недвижимости, блоги риэлторов. Обсуждения, комментарии',
      metaKeywords: 'авторские колонки, блоги специалистов рынка недвижимости, блоги риэлторов',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/blogs/',
      noIndex: false,
      type: EType.Blogs,
      title: 'Блоги',
      breadCrumbName: 'Блоги',
      breadCrumbParents: ['/magazine/'],
      pathname: '/blogs/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Specialist,
      metaTitle: 'Специалист-специалисту - блог - ЦИАН',
      metaDescription:
        'Специалист-специалисту - блог, полезная информация о недвижимости. Вся информация о для специалиста в блоге - ЦИАН',
      metaKeywords: 'специалист-специалисту, блог, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/blogs-specialist/',
      noIndex: false,
      type: EType.Blogs,
      title: 'Блоги',
      breadCrumbName: 'Специалист–специалисту',
      breadCrumbParents: ['/magazine/', '/blogs/'],
      pathname: '/blogs-specialist/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Market_trend,
      metaTitle: 'Тенденции рынка недвижимости - блог - ЦИАН',
      metaDescription:
        'Тенденции рынка недвижимости - блог, полезная информация о недвижимости. Вся информация о тенденциях рынка в блоге - ЦИАН',
      metaKeywords: 'тенденции рынка, блог, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/blogs-tendentsiy-rynka/',
      noIndex: false,
      type: EType.Blogs,
      title: 'Блоги',
      breadCrumbName: 'Тенденции рынка',
      pathname: '/blogs-tendentsiy-rynka/',
      breadCrumbParents: ['/magazine/', '/blogs/'],
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: null,
      metaTitle: 'Мой блог - ЦИАН',
      metaDescription:
        'Мой блог - блог, полезная информация о недвижимости. Авторские информационные и аналитические обзоры',
      metaKeywords: 'авторские колонки, блоги риэлторов',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/moi-blog/',
      noIndex: false,
      type: EType.Blogs,
      title: 'Мой блог',
      breadCrumbName: 'Мой блог',
      breadCrumbParents: ['/magazine/', '/blogs/'],
      pathname: '/moi-blog/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 11,
      category: null,
      metaTitle: 'Новостройки - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Новостройки - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'новостройки, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-novostrojki-stati/',
      noIndex: false,
      type: EType.Articles,
      title: 'Новостройки',
      breadCrumbName: 'Новостройки',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-novostrojki-stati/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 12,
      category: null,
      metaTitle: 'Вторичная - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Вторичная - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'вторичная, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-vtorichnaya/',
      noIndex: false,
      type: EType.Articles,
      title: 'Вторичная недвижимость',
      breadCrumbName: 'Вторичная',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-vtorichnaya/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 15,
      category: null,
      metaTitle: 'Аренда - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Аренда - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'аренда, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-arenda/',
      noIndex: false,
      type: EType.Articles,
      title: 'Аренда недвижимости',
      breadCrumbName: 'Аренда',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-arenda/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 16,
      category: null,
      metaTitle: 'Ипотека - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Ипотека - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'ипотека, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-ipoteka-stati/',
      noIndex: false,
      type: EType.Articles,
      title: 'Ипотека',
      breadCrumbName: 'Ипотека',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-ipoteka-stati/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 13,
      category: null,
      metaTitle: 'Загородная - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Загородная - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'загородная, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-zagorodnaya/',
      noIndex: false,
      type: EType.Articles,
      title: 'Загородная недвижимость',
      breadCrumbName: 'Загородная',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-zagorodnaya/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 31,
      category: null,
      metaTitle: 'Строим дом - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Строим дом - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'строим дом, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-stroim-dom/',
      noIndex: false,
      type: EType.Articles,
      title: 'Строим дом',
      breadCrumbName: 'Строим дом',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-stroim-dom/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 17,
      category: null,
      metaTitle: 'Дизайн и Ремонт - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Дизайн и Ремонт - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'дизайн и ремонт, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-dizajn-i-remont/',
      noIndex: false,
      type: EType.Articles,
      title: 'Дизайн и ремонт',
      breadCrumbName: 'Дизайн и ремонт',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-dizajn-i-remont/',
      audienceAccessType: EAudienceAccessType.B2c,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 14,
      category: null,
      metaTitle: 'Коммерческая - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Коммерческая - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'коммерческая, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-kommercheskaya/',
      noIndex: false,
      type: EType.Articles,
      title: 'Коммерческая недвижимость',
      breadCrumbName: 'Коммерческая',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-kommercheskaya/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 20,
      category: null,
      metaTitle: 'Гайды - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Гайды - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'гайды, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-pomoshnik-po-nedvizhimosti/',
      noIndex: false,
      type: EType.Articles,
      title: 'Гайды',
      breadCrumbName: 'Гайды',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-pomoshnik-po-nedvizhimosti/',
      audienceAccessType: EAudienceAccessType.B2c,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 21,
      category: null,
      metaTitle: 'Шаблоны документов - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Шаблоны документов - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'шаблоны документов, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-biblioteka-dokumentov/',
      noIndex: false,
      type: EType.Documents,
      title: 'Шаблоны документов',
      breadCrumbName: 'Шаблоны документов',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-biblioteka-dokumentov/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 18,
      category: null,
      metaTitle: 'Город - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Город - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'город, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-gorod/',
      noIndex: false,
      type: EType.Articles,
      title: 'Жизнь города',
      breadCrumbName: 'Город',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-gorod/',
      audienceAccessType: EAudienceAccessType.B2c,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 32,
      category: null,
      metaTitle: 'Редакция - статьи, интервью, обзоры, исследования и аналитика',
      metaDescription: 'Редакция - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'редакция, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-o-redakcii-cianzhurnala/',
      noIndex: false,
      type: EType.Articles,
      title: 'Редакция',
      breadCrumbName: 'Редакция',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-o-redakcii-cianzhurnala/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 30,
      category: null,
      metaTitle: 'Календарь событий - статьи, интервью, обзоры, исследования и аналитик',
      metaDescription: 'Календарь событий - статьи, интервью, обзоры, исследования и аналитика рынка недвижимости',
      metaKeywords: 'календарь событий, статьи, интервью, обзоры, исследования, аналитика рынка недвижимости',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/magazine-kalendar-sobytij/',
      noIndex: false,
      type: EType.Articles,
      title: 'Календарь событий',
      breadCrumbName: 'Календарь событий',
      breadCrumbParents: ['/magazine/'],
      pathname: '/magazine-kalendar-sobytij/',
      audienceAccessType: EAudienceAccessType.B2b,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: null,
      metaTitle: 'Советы риэлторов и других специалистов недвижимости России - ЦИАН',
      metaDescription:
        'ЦИАН - форум о недвижимости, советы риэлторов и других специалистов недвижимости. Задать вопрос риэлтору',
      metaKeywords: 'недвижимость, форум, советы, вопрос-ответ',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/forum-rieltorov/',
      noIndex: false,
      type: EType.Questions,
      title: 'Вопросы риелтору',
      breadCrumbName: 'Вопросы риелтору',
      breadCrumbParents: ['/magazine/'],
      pathname: '/forum-rieltorov/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Specialist,
      metaTitle: 'Специалист-специалисту - советы и вопросы - ЦИАН',
      metaDescription:
        'Специалист-специалисту -  советы и вопросы, полезная информация о недвижимости. Вся информация о для специалиста - ЦИАН',
      metaKeywords: 'специалист-специалисту, статьи, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/forum-rieltorov-specialist/',
      noIndex: false,
      type: EType.Questions,
      title: 'Вопросы риелтору',
      breadCrumbName: 'Специалист–специалисту',
      breadCrumbParents: ['/magazine/', '/forum-rieltorov/'],
      pathname: '/forum-rieltorov-specialist/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Market_trend,
      metaTitle: 'Тенденции рынка недвижимости - советы и вопросы - ЦИАН',
      metaDescription:
        'Тенденции рынка недвижимости -  советы и вопросы, полезная информация о недвижимости. Вся информация о тенденциях рынка - ЦИАН',
      metaKeywords: 'тенденции рынка, статьи, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/forum-rieltorov-tendentsiy-rynka/',
      noIndex: false,
      type: EType.Questions,
      title: 'Вопросы риелтору',
      breadCrumbName: 'Тенденции рынка',
      breadCrumbParents: ['/magazine/', '/forum-rieltorov/'],
      pathname: '/forum-rieltorov-tendentsiy-rynka/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.City_realty,
      metaTitle: 'Городская недвижимость - советы и вопросы - ЦИАН',
      metaDescription:
        'Городская недвижимость - советы и вопросы, полезная информация о недвижимости. Вся информация о городской недвижимости - ЦИАН',
      metaKeywords: 'городская недвижимость, статьи, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/forum-rieltorov-gorodskaya-nedvizhimost/',
      noIndex: false,
      type: EType.Questions,
      title: 'Вопросы риелтору',
      breadCrumbName: 'Городская недвижимость',
      breadCrumbParents: ['/magazine/', '/forum-rieltorov/'],
      pathname: '/forum-rieltorov-gorodskaya-nedvizhimost/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Commerce_realty,
      metaTitle: 'Коммерческая недвижимость - советы и вопросы - ЦИАН',
      metaDescription:
        'Коммерческая недвижимость - советы и вопросы, полезная информация о недвижимости. Вся информация о коммерческой недвижимости - ЦИАН',
      metaKeywords: 'коммерческая недвижимость, статьи, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/forum-rieltorov-kommercheskaya-nedvizhimost/',
      noIndex: false,
      type: EType.Questions,
      title: 'Вопросы риелтору',
      breadCrumbName: 'Коммерческая недвижимость',
      breadCrumbParents: ['/magazine/', '/forum-rieltorov/'],
      pathname: '/forum-rieltorov-kommercheskaya-nedvizhimost/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Country_realty,
      metaTitle: 'Загородная недвижимость - советы и вопросы - ЦИАН',
      metaDescription:
        'Загородная недвижимость - советы и вопросы, полезная информация о недвижимости. Вся информация о загородной недвижимости - ЦИАН',
      metaKeywords: 'загородная недвижимость, статьи, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/forum-rieltorov-zagorodnaya-nedvizhimost/',
      noIndex: false,
      type: EType.Questions,
      title: 'Вопросы риелтору',
      breadCrumbName: 'Загородная недвижимость',
      breadCrumbParents: ['/magazine/', '/forum-rieltorov/'],
      pathname: '/forum-rieltorov-zagorodnaya-nedvizhimost/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Foreign_realty,
      metaTitle: 'Зарубежная недвижимость - советы и вопросы - ЦИАН',
      metaDescription:
        'Зарубежная недвижимость - советы и вопросы, полезная информация о недвижимости. Вся информация о зарубежной недвижимости - ЦИАН',
      metaKeywords: 'зарубежная недвижимость, статьи, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/forum-rieltorov-zarubezhnaya-nedvizhimost/',
      noIndex: false,
      type: EType.Questions,
      title: 'Вопросы риелтору',
      breadCrumbName: 'Зарубежная недвижимость',
      breadCrumbParents: ['/magazine/', '/forum-rieltorov/'],
      pathname: '/forum-rieltorov-zarubezhnaya-nedvizhimost/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    {
      rubricId: 0,
      category: ECategory.Hypothec,
      metaTitle: 'Ипотека - советы и вопросы - ЦИАН',
      metaDescription:
        'Ипотека - советы и вопросы, полезная информация о недвижимости. Вся информация о ипотеке - ЦИАН',
      metaKeywords: 'ипотека, статьи, циан',
      metaImage: '',
      canonicalUrl: 'https://www.cian.ru/forum-rieltorov-ipoteka/',
      noIndex: false,
      type: EType.Questions,
      title: 'Вопросы риелтору',
      breadCrumbName: 'Ипотека',
      breadCrumbParents: ['/magazine/', '/forum-rieltorov/'],
      pathname: '/forum-rieltorov-ipoteka/',
      audienceAccessType: null,
      userAccessType: EUserAccessType.Unauthorised,
    },
    ...(data || []),
  ];
};

export const mkPagesMetaState = (data?: Partial<TPagesMetaState>): TPagesMetaState => {
  return {
    ...defaultState,
    items: mkPagesMeta(),
    ...data,
  };
};
